import _ from 'lodash'
import {
  GetContextMenuItemsParams,
  MenuItemDef,
  IRowNode,
} from 'ag-grid-community'
import {
  createNewDevelopmentEventWbsItemStatusMappingRow,
  DevelopmentEventWbsItemStatusMappingRow,
} from '../developmentEventWbsItemStatusMapping'
import { intl } from '../../../../i18n'
import {
  ContextMenuItemId,
  getMenuIconHtml,
} from '../../../containers/commons/AgGrid/lib/contextMenu'
import { focusRow } from '../../../containers/BulkSheetView/lib/gridApi'

export const addRowMenuItems = (
  params: GetContextMenuItemsParams,
  data: DevelopmentEventWbsItemStatusMappingRow[],
  setData: (
    d: DevelopmentEventWbsItemStatusMappingRow[],
    r: DevelopmentEventWbsItemStatusMappingRow[]
  ) => void,
  projectUuid: string
): MenuItemDef[] => {
  if (!projectUuid) return []

  return [
    {
      name: intl.formatMessage({
        id: 'bulksheet.contextMenu.insert.row',
      }),
      icon: getMenuIconHtml(ContextMenuItemId.ADD_ROW),
      action: () => {
        const newRow =
          createNewDevelopmentEventWbsItemStatusMappingRow(projectUuid)
        const newData = [...data, newRow]
        const newRows = newData.filter(v => v.uuid === newRow.uuid)
        setData(newData, newRows)
        focusRow(params.api, newRow.uuid)
      },
    },
  ]
}

export const deleteRowMenuItems = (
  selectedNodes: IRowNode<DevelopmentEventWbsItemStatusMappingRow>[],
  action: () => void
): MenuItemDef[] => {
  return [
    {
      name: intl.formatMessage(
        { id: 'bulksheet.contextMenu.delete' },
        { count: selectedNodes.length }
      ),
      icon: getMenuIconHtml(ContextMenuItemId.REMOVE_ROW),
      action,
      shortcut: intl.formatMessage({
        id: 'bulksheet.contextMenu.shortcut.row.delete',
      }),
    },
  ]
}
